import { render, staticRenderFns } from "./my_list_index.vue?vue&type=template&id=53e5ec0b&lang=pug"
import script from "./my_list_index.vue?vue&type=script&lang=js"
export * from "./my_list_index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports